import type { Orientation } from 'types/common_types';

export function getOrientation(w: number, h: number): Orientation {
  if (w === h) return 'square';
  if (w > h) return 'landscape';
  return 'portrait';
}
